import React, { useEffect, useState, useRef } from "react"
import Overlay from "../../components/Overlay"
import RegisterUser from "../../components/RegisterUser"
import { useAuthUser } from "react-auth-kit"
import List from "../../components/Stats/List"
const HomePage = () => {
	const auth = useAuthUser()
	const user = auth()

	const [token] = useState(
		"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiN2JjNThjNTUtMWFmZC00YjVhLTlhNzEtN2QxMWQ2MTFhZDQxIiwidXNlcm5hbWUiOiJncm91cGFkbWluMkBjYXJlZ2l2ZXIuY29tIiwic3RhdHVzIjoiQUNUSVZFIiwidHlwZSI6Imdyb3VwLWFkbWluIiwicm9sZXMiOlsiR1JPVVBfTUFOQUdFTUVOVF9BRE1JTiJdLCJwZXJtaXNzaW9ucyI6W119LCJpYXQiOjE2MDU3NjIwMjIsImV4cCI6MTYwODM1NDAyMn0.SBfLq-aPMco3gdqM4JAyJ8xMc_0cxv1-JZ9mgyXhFx0"
	)
	const [url] = useState(
		`https://api.baobabcircle.com/care-giver/patients/search`
	)
	const [country, setCountry] = useState("254")
	const [contacts, setContacts] = useState(null)
	const [phone, setPhone] = useState("")
	const [isOpen, setIsOpen] = useState(false)
	const [phoneError, setPhoneError] = useState("")
	const [newUser, setNewUser] = useState(false)
	const [loading, setLoading] = useState(false)
	const phoneRef = useRef(null)

	const [register, setRegister] = useState("Fetching Data")
	const [attendanceColor, setAttendanceColor] = useState("#d1d1d1")

	const currentMonth = String(new Date().getMonth() + 1).padStart(2, "0")
	const currentYear = new Date().getFullYear()
	const currentDay = new Date().getDate()
	const attendances_url = `${
		process.env.REACT_APP_BASE_URL
	}/api/v2/che-tool/attendances?startDate=${currentYear}-${currentMonth}-${String(
		currentDay
	).padStart(2, "0")}&endDate=${currentYear}-${currentMonth}-${String(
		currentDay
	).padStart(
		2,
		"0"
	)}&page=0&size=20&attendanceTypes=A&attendanceTypes=P&attendanceTypes=PL&attendanceTypes=SL&attendanceTypes=UL&attendanceTypes=H`

	useEffect(() => {
		fetch(attendances_url, {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				apiKey: user.apikey,
				// apiKey: `zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
			},
		})
			.then((response) => response.json())
			.then((result) => {
				if (result.content[0].attendanceType === "P") {
					setRegister("Present")
					setAttendanceColor("#3fa456")
				} else if (result.content[0].attendanceType) {
					setRegister("Away")
					setAttendanceColor("#ff7373")
				} else {
					setRegister("Please mark attendance")
					setAttendanceColor("#d1d1d1")
				}
			})
			.catch((error) => {
				console.log(error)
			})
	}, [attendances_url, user.apikey])

	const handleCountry = (event) => {
		setCountry(event.target.value)
	}
	const handleInput = (event) => {
		event.preventDefault()
		setPhone(event.target.value.replace(/^0/, ""))
	}
	const handlePhone = (event) => {
		event.preventDefault()
		setLoading(true)
		if (phone.length < 7 && phone.length >= 1) {
			setLoading(false)
			setContacts("")
			setPhoneError("Enter a complete number")
		} else if (phone.length === 0) {
			setLoading(false)
			setContacts("")
			setPhoneError("")
			return
		} else {
			const number = country + phone
			fetch(url, {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: "Bearer " + token,
					// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
				},
				body: JSON.stringify({
					msisdn: number,
				}),
			})
				.then((response) => response.json())
				.then((result) => {
					if (result.message === "RESULTS FOUND.") {
						setContacts(result.data.patients)
						setLoading(false)
					} else {
						setContacts()
						setLoading(false)
						setPhoneError(
							`No contacts found matching ${
								country + phone
							} , would you like to register new user`
						)
						setNewUser(true)
					}
				})
				.catch((error) => {
					console.log(error)
					setLoading(false)
					setPhoneError("Something went wrong, please try again")
				})
			setPhoneError("")
		}
	}
	useEffect(() => {
		return function () {
			window.scrollTo(0, 0)
		}
	}, [])

	return (
		<section className="max-w-[1090px] w-full mx-auto px-[19px] sm:grid sm:pb-[80px]">
			<div className="flex justify-between py-[19px]">
				<div className="">
					<div className="text-[20px] font-bold">Search Contacts</div>
					<div
						className="text-[13px] mt-[3px]"
						style={{ color: attendanceColor }}
					>
						{register}
					</div>
				</div>
			</div>
			<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] sm:mt-[19px] mt-[10px] w-full sm:order-3">
				<div className="flex">
					<div className="text-[17px] font-medium">
						Search Contacts
					</div>
				</div>
				<form
					onSubmit={handlePhone}
					className="grid sm:flex sm:flex-col md:grid-cols-[1fr_1fr_133px] gap-[16px]"
				>
					<div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							Country Code
						</div>
						<select
							id="countries"
							name="countries"
							className="border-[#f2994a] border-[1px] rounded-[3px] text-[#f2994a] h-[32px] my-[2px] ml-[2px] outline-none  px-[5px] text-[14px]"
							onChange={handleCountry}
						>
							<option value="254" defaultValue>
								Kenya (+254)
							</option>
							<option value="256">Uganda (+256)</option>
							<option value="263">Zimbabwe (+263)</option>
						</select>
					</div>
					<div className="flex flex-col">
						<div className="text-[13px] font-medium] pl-[10px] pb-[5px]">
							Phone Number
						</div>
						<input
							required
							id="phone"
							ref={phoneRef}
							onChange={handleInput}
							type="number"
							placeholder="Phone number"
							className="  text-[#333333] rounded-[3px] h-[32px] my-[2px] ml-[2px] outline-none  px-[10px] text-[14px] shadow-inner-custom"
						/>
					</div>
					<div className="flex flex-col">
						<div className="sm:hidden text-[13px] font-medium] pl-[10px] pb-[5px] opacity-0">
							Action
						</div>
						<button
							type="submit"
							className="text-white bg-[#f2994a] rounded-[3px] flex h-[32px] text-[14px] mt-[2px]"
						>
							<span className="m-auto flex justify-center gap-[0.2rem]">
								<span className="text-[12px]">Lookup User</span>
								<span>
									<svg
										className="w-[12px]"
										viewBox="0 0 16 19"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M14 13.9247L10.9273 10.852C11.6657 9.96558 12.0339 8.82859 11.9553 7.67759C11.8768 6.52659 11.3575 5.45018 10.5055 4.6723C9.65352 3.89442 8.53443 3.47495 7.38105 3.50116C6.22766 3.52737 5.12878 3.99723 4.31301 4.81301C3.49723 5.62878 3.02737 6.72766 3.00116 7.88105C2.97495 9.03443 3.39442 10.1535 4.1723 11.0055C4.95018 11.8575 6.02659 12.3768 7.17759 12.4553C8.32859 12.5339 9.46558 12.1657 10.352 11.4273L13.4247 14.5L14 13.9247ZM3.82829 7.9901C3.82829 7.26586 4.04305 6.55789 4.44541 5.95571C4.84778 5.35352 5.41968 4.88418 6.08879 4.60703C6.7579 4.32987 7.49417 4.25736 8.20449 4.39865C8.91481 4.53994 9.56729 4.88869 10.0794 5.40081C10.5915 5.91292 10.9403 6.5654 11.0816 7.27572C11.2229 7.98604 11.1503 8.72231 10.8732 9.39142C10.596 10.0605 10.1267 10.6324 9.5245 11.0348C8.92232 11.4372 8.21434 11.6519 7.4901 11.6519C6.51926 11.6508 5.58849 11.2647 4.902 10.5782C4.21551 9.89172 3.82936 8.96095 3.82829 7.9901Z"
											fill="white"
											stroke="white"
											strokeWidth="0.6"
										/>
									</svg>
								</span>
							</span>
						</button>
					</div>
				</form>
			</div>
			<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] mt-[19px] sm:order-4 w-full flex-grow">
				<div className="flex justify-between">
					<div className="text-[17px] font-medium">Users</div>
				</div>
				<div className="border-t-[1px] border-[#fff5eb] h-full grow-[1]">
					{contacts === null && (
						<div className="py-[3rem]">
							<svg
								className="w-full md:w-[20rem] mx-auto"
								viewBox="0 0 500 374"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M500 328.398H0V328.648H500V328.398Z"
									fill="#EBEBEB"
								/>
								<path
									d="M449.901 344.494H416.779V344.744H449.901V344.494Z"
									fill="#EBEBEB"
								/>
								<path
									d="M331.22 347.208H322.527V347.458H331.22V347.208Z"
									fill="#EBEBEB"
								/>
								<path
									d="M415.778 335.208H396.586V335.458H415.778V335.208Z"
									fill="#EBEBEB"
								/>
								<path
									d="M95.652 336.888H52.459V337.138H95.652V336.888Z"
									fill="#EBEBEB"
								/>
								<path
									d="M110.889 336.888H104.556V337.138H110.889V336.888Z"
									fill="#EBEBEB"
								/>
								<path
									d="M225.147 341.111H131.471V341.361H225.147V341.111Z"
									fill="#EBEBEB"
								/>
								<path
									d="M237.014 283.8H43.915C40.768 283.8 38.207 281.239 38.207 278.092V6.66C38.207 3.513 40.768 0.951996 43.915 0.951996H237.014C240.16 0.951996 242.721 3.513 242.721 6.66V278.092C242.721 281.239 240.16 283.8 237.014 283.8ZM43.915 1.203C40.905 1.203 38.457 3.651 38.457 6.661V278.093C38.457 281.103 40.905 283.551 43.915 283.551H237.014C240.023 283.551 242.471 281.103 242.471 278.093V6.66C242.471 3.651 240.023 1.202 237.014 1.202L43.915 1.203Z"
									fill="#EBEBEB"
								/>
								<path
									d="M453.31 283.8H260.212C257.065 283.8 254.505 281.239 254.505 278.092V6.66C254.505 3.513 257.066 0.951996 260.212 0.951996H453.31C456.458 0.951996 459.018 3.513 459.018 6.66V278.092C459.019 281.239 456.458 283.8 453.31 283.8ZM260.212 1.203C257.203 1.203 254.755 3.651 254.755 6.661V278.093C254.755 281.103 257.203 283.551 260.212 283.551H453.31C456.32 283.551 458.768 281.103 458.768 278.093V6.66C458.768 3.651 456.32 1.202 453.31 1.202L260.212 1.203Z"
									fill="#EBEBEB"
								/>
								<path
									d="M54.9741 328.397H82.1621L82.1621 255.955H54.9741L54.9741 328.397Z"
									fill="#E6E6E6"
								/>
								<path
									d="M60.1381 328.398H54.9741V309.254H65.5521L60.1381 328.398Z"
									fill="#F0F0F0"
								/>
								<path
									d="M210.102 328.397H237.29V255.955H210.102V328.397Z"
									fill="#E6E6E6"
								/>
								<path
									d="M54.9736 323.173H214.609V255.956H54.9736V323.173Z"
									fill="#F0F0F0"
								/>
								<path
									d="M209.445 328.398H214.609V309.254H204.03L209.445 328.398Z"
									fill="#F0F0F0"
								/>
								<path
									d="M209.8 315.08H161.48V263.364H209.8V315.08ZM162.48 314.08H208.8V264.364H162.48V314.08Z"
									fill="#E6E6E6"
								/>
								<path
									d="M158.951 315.08H110.631V263.364H158.951V315.08ZM111.631 314.08H157.951V264.364H111.631V314.08Z"
									fill="#E6E6E6"
								/>
								<path
									d="M108.103 315.08H59.781V263.364H108.102L108.103 315.08ZM60.781 314.08H107.102V264.364H60.781V314.08Z"
									fill="#E6E6E6"
								/>
								<path
									d="M271.464 177.659L431.67 177.659V41.2502L271.464 41.2502V177.659Z"
									fill="#E6E6E6"
								/>
								<path
									d="M267.859 177.659L430.104 177.659V41.2502L267.859 41.2502V177.659Z"
									fill="#F5F5F5"
								/>
								<path
									d="M423.631 171.113V47.7973L274.33 47.7973V171.113L423.631 171.113Z"
									fill="#FAFAFA"
								/>
								<path
									d="M405.311 171.113L346.55 47.797H326.591L385.352 171.113H405.311Z"
									fill="white"
								/>
								<path
									d="M379.695 171.113L320.933 47.797H307.19L365.951 171.113H379.695Z"
									fill="white"
								/>
								<path
									d="M329.768 171.113V47.7969H322.047V171.113H329.768Z"
									fill="#E6E6E6"
								/>
								<path
									d="M381.087 171.112V47.7965H373.366V171.112H381.087Z"
									fill="#E6E6E6"
								/>
								<path
									d="M328.375 175.267V42.9297H318.616V175.267H328.375Z"
									fill="#F5F5F5"
								/>
								<path
									d="M379.694 175.266V42.9293H369.935V175.266H379.694Z"
									fill="#F5F5F5"
								/>
								<path
									d="M275.017 171.113V47.7974H274.33V171.113H275.017Z"
									fill="#E6E6E6"
								/>
								<path
									d="M265.141 32.832H438.706C439.165 32.832 439.541 33.208 439.541 33.667C439.541 34.126 439.165 34.502 438.706 34.502H265.141C264.682 34.502 264.306 34.126 264.306 33.667C264.306 33.208 264.682 32.832 265.141 32.832Z"
									fill="#E6E6E6"
								/>
								<path
									d="M431.67 38.341C432.29 38.341 432.797 37.834 432.797 37.214V34.794C432.797 34.174 432.29 33.667 431.67 33.667C431.05 33.667 430.543 34.174 430.543 34.794V37.214C430.543 37.834 431.05 38.341 431.67 38.341Z"
									fill="#E6E6E6"
								/>
								<path
									d="M277.728 38.341C278.348 38.341 278.855 37.834 278.855 37.214V34.794C278.855 34.174 278.348 33.667 277.728 33.667C277.108 33.667 276.601 34.174 276.601 34.794V37.214C276.601 37.834 277.108 38.341 277.728 38.341Z"
									fill="#E6E6E6"
								/>
								<path
									opacity="0.6"
									d="M265.408 101.369L427.534 101.369V33.6668L265.408 33.6668V101.369Z"
									fill="#E0E0E0"
								/>
								<path
									d="M113.245 255.956H90.5721C88.1611 255.956 86.2061 254.001 86.2061 251.59V212.418C86.2061 210.007 88.1611 208.052 90.5721 208.052H113.245C115.656 208.052 117.611 210.007 117.611 212.418V251.59C117.611 254.001 115.657 255.956 113.245 255.956Z"
									fill="#FAFAFA"
								/>
								<path
									d="M116.146 208.617H87.6721C86.8621 208.617 86.2061 207.961 86.2061 207.151V205.965C86.2061 205.155 86.8621 204.499 87.6721 204.499H116.146C116.956 204.499 117.612 205.155 117.612 205.965V207.151C117.611 207.961 116.955 208.617 116.146 208.617Z"
									fill="#E6E6E6"
								/>
								<path
									d="M199.331 255.956H182.875C181.125 255.956 179.706 254.537 179.706 252.787V224.356C179.706 222.606 181.125 221.187 182.875 221.187H199.331C201.081 221.187 202.5 222.606 202.5 224.356V252.787C202.5 254.537 201.081 255.956 199.331 255.956Z"
									fill="#F0F0F0"
								/>
								<path
									d="M201.436 221.598H180.77C180.183 221.598 179.706 221.122 179.706 220.534V219.673C179.706 219.085 180.182 218.609 180.77 218.609H201.436C202.024 218.609 202.5 219.085 202.5 219.673V220.534C202.5 221.121 202.024 221.598 201.436 221.598Z"
									fill="#E6E6E6"
								/>
								<path
									d="M147.122 255.956H115.964C112.65 255.956 109.964 253.27 109.964 249.956V234.021C109.964 230.707 112.65 228.021 115.964 228.021H147.122C150.436 228.021 153.122 230.707 153.122 234.021V249.956C153.122 253.269 150.436 255.956 147.122 255.956Z"
									fill="#F0F0F0"
								/>
								<path
									d="M151.108 228.799H111.978C110.865 228.799 109.964 227.897 109.964 226.785V225.156C109.964 224.043 110.866 223.142 111.978 223.142H151.108C152.221 223.142 153.122 224.044 153.122 225.156V226.785C153.122 227.897 152.22 228.799 151.108 228.799Z"
									fill="#F5F5F5"
								/>
								<path
									d="M282.435 328.398H287.473V245.755H282.435V328.398Z"
									fill="#E6E6E6"
								/>
								<path
									d="M427.956 229.672H400.666V245.755H427.956V229.672Z"
									fill="#E6E6E6"
								/>
								<path
									d="M264.986 245.755L400.667 245.755V229.672L264.986 229.672V245.755Z"
									fill="#F5F5F5"
								/>
								<path
									d="M427.956 272.618H400.666V288.701H427.956V272.618Z"
									fill="#E6E6E6"
								/>
								<path
									d="M264.986 288.702H400.667V272.619H264.986V288.702Z"
									fill="#F5F5F5"
								/>
								<path
									d="M418.116 328.398H423.154V245.755H418.116V328.398Z"
									fill="#E6E6E6"
								/>
								<path
									d="M395.629 328.398H400.667V245.755H395.629V328.398Z"
									fill="#F5F5F5"
								/>
								<path
									d="M264.986 328.398H270.024V245.755H264.986V328.398Z"
									fill="#F5F5F5"
								/>
								<path
									d="M69.6786 120.035L133.821 120.035V48.101L69.6786 48.101L69.6786 120.035Z"
									fill="#F0F0F0"
								/>
								<path
									d="M65.156 120.035L132.822 120.035V48.101L65.156 48.101L65.156 120.035Z"
									fill="#F5F5F5"
								/>
								<path
									d="M70.8247 53.7695V114.367H127.154V53.7695H70.8247Z"
									fill="white"
								/>
								<path
									d="M89.6481 66.599C85.2111 66.599 80.9951 69.203 79.1761 73.522C76.7651 79.246 79.4871 85.917 85.2251 88.328L127.158 105.974V81.421L93.9971 67.473C92.5761 66.88 91.0971 66.599 89.6481 66.599Z"
									fill="#F0F0F0"
								/>
								<path
									d="M154.858 156.002H219V84.068L154.858 84.068V156.002Z"
									fill="#F0F0F0"
								/>
								<path
									d="M150.336 156.002H218.002V84.068L150.336 84.068V156.002Z"
									fill="#F5F5F5"
								/>
								<path
									d="M156.003 89.7362V150.333H212.332V89.7362H156.003Z"
									fill="white"
								/>
								<path
									d="M190.509 113.165L156.006 98.646V123.778L181.531 134.512C187.406 136.98 194.233 134.194 196.701 128.32C199.169 122.461 196.383 115.633 190.509 113.165Z"
									fill="#F0F0F0"
								/>
								<path
									d="M250 373.561C357.082 373.561 443.889 368.492 443.889 362.238C443.889 355.984 357.082 350.915 250 350.915C142.918 350.915 56.1111 355.984 56.1111 362.238C56.1111 368.492 142.918 373.561 250 373.561Z"
									fill="#F5F5F5"
								/>
								<path
									d="M194.071 62.206C195.03 58 205.53 54 214.53 60.167C223.53 66.334 225.914 76.915 223.03 85.449C218.197 99.75 243.413 99.221 249.251 123.333C253.861 142.376 249.585 169.242 223.86 167.781C184.59 165.551 187.981 127.166 186.255 107C184.53 86.833 163.112 64.245 194.071 62.206Z"
									fill="#263238"
								/>
								<path
									d="M181.097 116.059C180.931 118.978 180.588 121.652 180.205 124.424C179.814 127.172 179.299 129.9 178.704 132.621C178.096 135.339 177.452 138.057 176.594 140.738C175.781 143.426 174.817 146.094 173.678 148.716L172.796 150.676C172.672 150.974 172.434 151.408 172.245 151.776C172.044 152.156 171.829 152.49 171.62 152.846C170.769 154.214 169.832 155.382 168.883 156.497C166.984 158.72 164.957 160.666 162.885 162.522C158.693 166.189 154.375 169.489 149.729 172.482L147.055 169.031C148.939 167.207 150.855 165.327 152.709 163.448C154.58 161.58 156.393 159.663 158.128 157.721C159.873 155.794 161.534 153.813 162.981 151.827C163.699 150.835 164.345 149.823 164.857 148.873C164.969 148.64 165.106 148.399 165.201 148.176C165.298 147.935 165.385 147.779 165.503 147.45L166.175 145.69C167.913 140.961 169.146 135.935 170.152 130.858C170.663 128.317 171.026 125.738 171.41 123.167C171.781 120.617 172.074 117.95 172.299 115.506L181.097 116.059Z"
									fill="#BE8A5C"
								/>
								<path
									d="M175.098 105.555C171.546 106.459 169.061 121.078 169.061 121.078L182.647 130.317C182.647 130.317 188.236 112.987 185.503 109.082C182.657 105.015 180.282 104.235 175.098 105.555Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.2"
									d="M175.419 108.82L172.69 123.555L178.192 127.286L175.419 108.82Z"
									fill="black"
								/>
								<path
									d="M148.68 167.781L139.528 169.242L144.745 175.024C144.745 175.024 150.14 173.791 151.086 170.335L148.68 167.781Z"
									fill="#BE8A5C"
								/>
								<path
									d="M135.199 170.387L140.419 176.041L144.745 175.025L139.528 169.242L135.199 170.387Z"
									fill="#BE8A5C"
								/>
								<path
									d="M194.317 351.604H185.698L185.123 331.644H193.742L194.317 351.604Z"
									fill="#BE8A5C"
								/>
								<path
									d="M253.922 326.202L245.943 329.46L235.833 312.028L243.813 308.77L253.922 326.202Z"
									fill="#BE8A5C"
								/>
								<path
									d="M244.44 328.264L252.764 323.317C253.067 323.137 253.438 323.201 253.656 323.472L258.518 329.495C259.022 330.12 258.819 331.115 258.113 331.518C255.181 333.193 253.681 333.853 250.02 336.029C247.768 337.367 242.473 341.953 239.363 343.801C236.321 345.608 234.26 342.672 235.389 341.624C240.454 336.925 242.491 332.26 243.471 329.455C243.649 328.949 243.997 328.527 244.44 328.264Z"
									fill="#263238"
								/>
								<path
									d="M185.403 350.606H195.086C195.438 350.606 195.724 350.851 195.774 351.195L196.877 358.856C196.991 359.651 196.308 360.403 195.495 360.389C192.119 360.331 190.492 360.133 186.234 360.133C183.614 360.133 178.195 360.405 174.578 360.405C171.04 360.405 170.767 356.828 172.274 356.504C179.029 355.051 181.687 353.048 183.962 351.137C184.373 350.792 184.887 350.606 185.403 350.606Z"
									fill="#263238"
								/>
								<g opacity="0.2">
									<path
										d="M185.125 331.65L185.42 341.938H194.042L193.747 331.65H185.125Z"
										fill="black"
									/>
									<path
										d="M243.817 308.774L235.834 312.033L241.049 321.017L249.032 317.758L243.817 308.774Z"
										fill="black"
									/>
								</g>
								<path
									d="M175.098 105.555C175.098 105.555 170.992 107.001 179.217 157.575C193.107 157.575 207.463 157.575 214.222 157.575C213.635 143.328 213.618 134.543 220.427 105.305C220.427 105.305 213.093 103.71 205.562 103.347C199.671 103.063 194.845 102.875 189.667 103.348C182.84 103.971 175.098 105.555 175.098 105.555Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.2"
									d="M217.54 116.88C214.37 117.67 211.44 121.13 211.79 127.5C212 131.32 213.75 134.21 214.71 135.52C215.27 130.62 216.21 124.93 217.7 117.65L217.54 116.88Z"
									fill="black"
								/>
								<path
									d="M191.51 117.333C191.51 117.333 196.058 120.139 197.251 124.305C202.187 120.688 208.901 110.616 209.167 104.591C209.199 103.858 208.577 103.265 207.843 103.254C206.408 103.232 205.564 103.347 205.564 103.347L191.51 117.333Z"
									fill="#FAFAFA"
								/>
								<path
									d="M191.51 117.333C191.51 117.333 186.962 120.139 185.77 124.305C180.463 120.416 183.407 107.583 186.447 103.308C188.641 103.165 189.668 103.347 189.668 103.347L191.51 117.333Z"
									fill="#FAFAFA"
								/>
								<path
									d="M203.988 85.449C202.985 90.564 201.985 99.934 205.563 103.347C205.563 103.347 200.836 112.417 191.51 117.333C184.419 111.666 189.668 103.347 189.668 103.347C195.371 101.985 195.224 97.754 194.231 93.78L203.988 85.449Z"
									fill="#BE8A5C"
								/>
								<path
									opacity="0.2"
									d="M200.01 88.848L194.235 93.776C194.473 94.717 194.659 95.67 194.725 96.597C196.904 96.282 200.33 94.426 200.798 92.057C201.019 90.935 200.195 89.378 200.01 88.848Z"
									fill="black"
								/>
								<path
									d="M212.562 77.234C210.197 85.455 209.372 88.985 204.212 92.327C196.45 97.354 186.869 92.652 186.73 83.891C186.605 76.005 190.492 63.886 199.388 62.383C208.152 60.901 214.927 69.013 212.562 77.234Z"
									fill="#BE8A5C"
								/>
								<path
									d="M194.808 63.111C195.197 65.889 210.419 74.833 213.308 70.167C216.197 65.5 212.04 62 205.563 61.111C199.086 60.222 194.808 63.111 194.808 63.111Z"
									fill="#263238"
								/>
								<path
									d="M204.725 64.616C202.855 67.082 206.815 84.796 212.488 83.131C218.161 81.467 217.897 75.794 213.957 70.561C210.016 65.327 204.725 64.616 204.725 64.616Z"
									fill="#263238"
								/>
								<path
									d="M179.217 157.576C179.217 157.576 172.419 223.97 172.983 250.254C173.571 277.593 183.589 339.946 183.589 339.946H195.244C195.244 339.946 193.4 279.191 194.43 252.341C195.553 223.07 204.851 157.576 204.851 157.576H179.217Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M179.217 157.576C179.217 157.576 172.419 223.97 172.983 250.254C173.571 277.593 183.589 339.946 183.589 339.946H195.244C195.244 339.946 193.4 279.191 194.43 252.341C195.553 223.07 204.851 157.576 204.851 157.576H179.217Z"
									fill="black"
								/>
								<path
									d="M196.254 340.363H182.579L181.576 336.001L196.89 335.468L196.254 340.363Z"
									fill="#263238"
								/>
								<path
									opacity="0.2"
									d="M194.316 174.095C185.718 191.391 192.59 222.943 195.63 234.681C197.189 217.051 199.818 195.501 201.867 179.675C200.564 170.721 198.281 166.121 194.316 174.095Z"
									fill="black"
								/>
								<path
									d="M188.461 157.576C188.461 157.576 196.391 226.601 202.379 248.761C209.489 275.07 238.369 319.959 238.369 319.959L249.251 315.517C249.251 315.517 230.6 264.406 225.165 250.546C213.564 220.964 223.494 176.88 214.223 157.576H188.461Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M188.461 157.576C188.461 157.576 196.391 226.601 202.379 248.761C209.489 275.07 238.369 319.959 238.369 319.959L249.251 315.517C249.251 315.517 230.6 264.406 225.165 250.546C213.564 220.964 223.494 176.88 214.223 157.576H188.461Z"
									fill="black"
								/>
								<path
									d="M250.737 315.574L237.237 321.085L234.067 317.428L249.655 310.229L250.737 315.574Z"
									fill="#263238"
								/>
								<path
									d="M91.61 69.761C67.293 91.282 65.031 128.448 86.553 152.765C108.074 177.082 145.234 179.349 169.551 157.827C193.868 136.306 196.14 99.141 174.619 74.824C153.098 50.507 115.927 48.24 91.61 69.761ZM163.385 150.86C142.917 168.975 111.636 167.066 93.521 146.599C75.402 126.126 77.309 94.844 97.777 76.73C118.25 58.61 149.532 60.518 167.651 80.992C185.766 101.458 183.858 132.74 163.385 150.86Z"
									fill="#263238"
								/>
								<path
									opacity="0.3"
									d="M127.819 159.066C102.818 157.541 83.784 136.035 85.309 111.034C86.834 86.026 108.341 66.992 133.342 68.517C158.35 70.042 177.384 91.549 175.858 116.557C174.334 141.558 152.827 160.592 127.819 159.066Z"
									fill="#F19B3D"
								/>
								<g opacity="0.5">
									<path
										d="M133.341 68.52C133.055 68.502 132.776 68.485 132.489 68.476L85.3711 110.176C85.3461 110.462 85.3281 110.748 85.3111 111.035C84.6881 121.259 87.5101 130.9 92.7671 138.834L160.036 79.299C152.808 73.117 143.573 69.144 133.341 68.52Z"
										fill="#FAFAFA"
									/>
									<path
										d="M164.391 83.557L96.4651 143.673C98.7311 146.266 101.292 148.597 104.105 150.618L170.355 91.984C168.692 88.947 166.689 86.121 164.391 83.557Z"
										fill="#FAFAFA"
									/>
								</g>
								<path
									d="M176.85 158.271L169.11 165.121C167.934 166.162 166.137 166.052 165.097 164.876C164.056 163.7 164.166 161.903 165.342 160.863L173.082 154.013C174.258 152.972 176.055 153.082 177.095 154.258C178.135 155.433 178.026 157.23 176.85 158.271Z"
									fill="#263238"
								/>
								<path
									d="M173.999 156.997C179.833 162.13 185.413 167.489 190.917 172.915C196.416 178.345 201.807 183.87 207.129 189.457C212.445 195.049 217.674 200.719 222.851 206.433C227.709 212.43 234.332 216.865 235.322 226.287C235.597 228.903 233.699 231.246 231.083 231.521C230.551 231.577 230.01 231.537 229.516 231.426C220.285 229.298 216.687 222.185 211.325 216.634C206.282 210.8 201.29 204.922 196.385 198.965C191.486 193.004 186.657 186.981 181.936 180.863C177.219 174.74 172.578 168.551 168.192 162.136C166.974 160.355 167.431 157.923 169.212 156.705C170.718 155.676 172.689 155.846 173.999 156.997Z"
									fill="#263238"
								/>
								<path
									d="M198.778 76.493C198.627 77.172 198.145 77.642 197.702 77.543C197.258 77.444 197.021 76.814 197.172 76.136C197.323 75.457 197.805 74.987 198.248 75.086C198.692 75.184 198.929 75.814 198.778 76.493Z"
									fill="#263238"
								/>
								<path
									d="M191.108 74.787C190.957 75.466 190.475 75.936 190.032 75.837C189.588 75.738 189.351 75.108 189.502 74.43C189.653 73.751 190.135 73.281 190.578 73.38C191.021 73.479 191.258 74.109 191.108 74.787Z"
									fill="#263238"
								/>
								<path
									d="M190.765 73.461L189.239 72.629C189.239 72.629 189.793 74.088 190.765 73.461Z"
									fill="#263238"
								/>
								<path
									d="M193.201 76.536C193.201 76.536 191.4 79.202 189.819 80.329C190.529 81.364 192.137 81.321 192.137 81.321L193.201 76.536Z"
									fill="#B67647"
								/>
								<path
									d="M195.248 84.801C194.925 84.78 194.586 84.733 194.232 84.654C194.122 84.63 194.052 84.521 194.076 84.411C194.101 84.3 194.211 84.226 194.32 84.256C197.301 84.913 199.152 83.146 199.17 83.128C199.251 83.049 199.38 83.05 199.459 83.131C199.538 83.211 199.536 83.341 199.456 83.42C199.383 83.491 197.834 84.972 195.248 84.801Z"
									fill="#263238"
								/>
								<path
									d="M213.108 85.435C212.126 86.911 210.553 87.796 209.12 88.06C206.964 88.457 206.083 86.481 206.847 84.55C207.535 82.812 209.486 80.51 211.57 80.988C213.624 81.458 214.231 83.747 213.108 85.435Z"
									fill="#BE8A5C"
								/>
								<path
									d="M201.973 73.496C201.809 73.549 201.623 73.495 201.517 73.348C200.407 71.82 197.974 71.837 197.95 71.837C197.725 71.84 197.539 71.66 197.536 71.435C197.532 71.21 197.71 71.024 197.938 71.021C198.055 71.019 200.82 71.002 202.178 72.868C202.31 73.05 202.27 73.306 202.088 73.438C202.052 73.464 202.013 73.483 201.973 73.496Z"
									fill="#263238"
								/>
								<path
									d="M189.511 69.169C189.372 69.16 189.241 69.08 189.173 68.947C189.071 68.746 189.151 68.501 189.352 68.398C191.364 67.374 193.01 68.296 193.078 68.336C193.274 68.449 193.341 68.698 193.228 68.894C193.116 69.089 192.868 69.155 192.671 69.045C192.605 69.008 191.32 68.313 189.722 69.127C189.655 69.159 189.582 69.173 189.511 69.169Z"
									fill="#263238"
								/>
								<path
									d="M241.133 331.534C241.099 331.53 241.065 331.525 241.031 331.518C240.648 331.439 240.364 331.184 240.186 330.758C240.052 330.437 240.142 330.2 240.242 330.058C240.872 329.156 243.986 329.271 244.338 329.287C244.426 329.289 244.491 329.343 244.52 329.419C244.549 329.495 244.53 329.581 244.471 329.638C243.673 330.409 242.2 331.658 241.133 331.534ZM243.826 329.681C242.58 329.672 240.909 329.816 240.577 330.291C240.535 330.351 240.496 330.44 240.563 330.6C240.687 330.897 240.868 331.067 241.114 331.117C241.696 331.247 242.689 330.705 243.826 329.681Z"
									fill="#F19B3D"
								/>
								<path
									d="M244.016 329.676C242.952 329.553 241.06 328.822 240.763 327.98C240.7 327.801 240.655 327.454 241.063 327.14C241.322 326.941 241.618 326.873 241.945 326.933C243.174 327.168 244.452 329.295 244.506 329.386C244.543 329.449 244.544 329.526 244.509 329.59C244.474 329.653 244.408 329.693 244.335 329.695C244.24 329.696 244.133 329.69 244.016 329.676ZM241.807 327.325C241.623 327.304 241.461 327.349 241.312 327.464C241.104 327.625 241.115 327.752 241.148 327.846C241.348 328.415 242.902 329.117 243.941 329.261C243.478 328.575 242.601 327.475 241.868 327.335C241.847 327.33 241.826 327.327 241.807 327.325Z"
									fill="#F19B3D"
								/>
								<path
									d="M182.167 352.113C181.31 352.113 180.519 351.98 180.076 351.582C179.795 351.329 179.671 350.995 179.708 350.588C179.73 350.345 179.85 350.157 180.054 350.046C181.112 349.464 184.546 351.222 184.934 351.424C185.011 351.464 185.054 351.548 185.042 351.634C185.03 351.72 184.965 351.789 184.88 351.806C184.147 351.95 183.116 352.113 182.167 352.113ZM180.631 350.329C180.473 350.329 180.343 350.352 180.25 350.403C180.166 350.449 180.124 350.517 180.115 350.624C180.09 350.9 180.167 351.113 180.349 351.277C180.872 351.748 182.29 351.83 184.201 351.512C183.018 350.946 181.447 350.329 180.631 350.329Z"
									fill="#F19B3D"
								/>
								<path
									d="M184.84 351.809C184.811 351.809 184.783 351.803 184.756 351.791C183.729 351.327 181.697 349.468 181.856 348.491C181.894 348.26 182.057 347.972 182.623 347.915C183.038 347.871 183.422 347.991 183.754 348.268C184.837 349.17 185.036 351.491 185.044 351.589C185.05 351.661 185.017 351.731 184.958 351.773C184.923 351.796 184.881 351.809 184.84 351.809ZM182.786 348.315C182.746 348.315 182.705 348.317 182.663 348.321C182.29 348.359 182.266 348.508 182.258 348.557C182.162 349.143 183.542 350.605 184.589 351.24C184.488 350.565 184.202 349.173 183.491 348.581C183.277 348.402 183.045 348.315 182.786 348.315Z"
									fill="#F19B3D"
								/>
								<path
									d="M198.436 75.166L196.91 74.334C196.91 74.334 197.464 75.793 198.436 75.166Z"
									fill="#263238"
								/>
								<path
									d="M214.746 155.521L215.641 158.654C215.763 158.897 215.476 159.145 215.071 159.145H179.044C178.728 159.145 178.467 158.99 178.447 158.792L178.131 155.659C178.109 155.442 178.383 155.258 178.728 155.258H214.176C214.437 155.258 214.667 155.365 214.746 155.521Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.2"
									d="M214.746 155.521L215.641 158.654C215.763 158.897 215.476 159.145 215.071 159.145H179.044C178.728 159.145 178.467 158.99 178.447 158.792L178.131 155.659C178.109 155.442 178.383 155.258 178.728 155.258H214.176C214.437 155.258 214.667 155.365 214.746 155.521Z"
									fill="black"
								/>
								<path
									d="M209.869 159.485H210.818C211.007 159.485 211.151 159.387 211.138 159.268L210.693 155.197C210.68 155.078 210.515 154.98 210.326 154.98H209.377C209.188 154.98 209.044 155.077 209.057 155.197L209.502 159.268C209.514 159.387 209.68 159.485 209.869 159.485Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M209.869 159.485H210.818C211.007 159.485 211.151 159.387 211.138 159.268L210.693 155.197C210.68 155.078 210.515 154.98 210.326 154.98H209.377C209.188 154.98 209.044 155.077 209.057 155.197L209.502 159.268C209.514 159.387 209.68 159.485 209.869 159.485Z"
									fill="white"
								/>
								<path
									d="M181.712 159.485H182.661C182.85 159.485 182.994 159.387 182.981 159.268L182.536 155.197C182.523 155.078 182.358 154.98 182.168 154.98H181.219C181.03 154.98 180.886 155.077 180.899 155.197L181.344 159.268C181.358 159.387 181.523 159.485 181.712 159.485Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M181.712 159.485H182.661C182.85 159.485 182.994 159.387 182.981 159.268L182.536 155.197C182.523 155.078 182.358 154.98 182.168 154.98H181.219C181.03 154.98 180.886 155.077 180.899 155.197L181.344 159.268C181.358 159.387 181.523 159.485 181.712 159.485Z"
									fill="white"
								/>
								<path
									d="M195.732 159.485H196.681C196.87 159.485 197.014 159.387 197.001 159.268L196.556 155.197C196.543 155.078 196.378 154.98 196.189 154.98H195.24C195.051 154.98 194.907 155.077 194.92 155.197L195.365 159.268C195.377 159.387 195.543 159.485 195.732 159.485Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M195.732 159.485H196.681C196.87 159.485 197.014 159.387 197.001 159.268L196.556 155.197C196.543 155.078 196.378 154.98 196.189 154.98H195.24C195.051 154.98 194.907 155.077 194.92 155.197L195.365 159.268C195.377 159.387 195.543 159.485 195.732 159.485Z"
									fill="white"
								/>
								<path
									d="M193.188 164.562L184.687 160.763L187.11 169.186C187.11 169.186 192.507 170.411 194.856 167.705L193.188 164.562Z"
									fill="#BE8A5C"
								/>
								<path
									d="M224.509 115.689C224.903 118.643 225.208 121.606 225.56 124.565L226.464 133.458C226.779 136.42 227.02 139.392 227.298 142.359L227.674 146.814L227.767 147.928C227.778 148.039 227.811 148.505 227.82 148.821C227.831 149.167 227.8 149.513 227.778 149.857C227.631 151.231 227.16 152.463 226.592 153.468C225.427 155.483 223.98 156.753 222.584 157.853C221.171 158.931 219.742 159.796 218.305 160.559C215.418 162.056 212.528 163.236 209.595 164.214C206.668 165.199 203.73 166.037 200.781 166.783C197.807 167.478 194.879 168.131 191.826 168.6L190.856 164.344C193.605 163.442 196.424 162.505 199.15 161.46C201.899 160.459 204.61 159.382 207.233 158.192C209.845 156.991 212.42 155.75 214.712 154.292C215.86 153.577 216.941 152.814 217.847 152.019C218.746 151.237 219.464 150.37 219.735 149.76C219.877 149.458 219.905 149.255 219.901 149.142C219.885 149.114 219.897 149.088 219.886 149.062C219.867 149.006 219.891 149.1 219.851 148.841L219.69 147.734L219.051 143.306C218.653 140.351 218.216 137.401 217.855 134.442L216.729 125.569C216.404 122.606 216.032 119.648 215.749 116.679L224.509 115.689Z"
									fill="#BE8A5C"
								/>
								<path
									d="M220.427 105.305C223.934 106.371 228.146 118.448 228.146 118.448L215.874 131.083C215.874 131.083 209.578 118.095 211.051 113.562C212.587 108.841 216.425 104.089 220.427 105.305Z"
									fill="#F19B3D"
								/>
								<path
									d="M177.655 162.511L180.065 169.454L187.11 169.186L184.687 160.762L177.655 162.511Z"
									fill="#BE8A5C"
								/>
								<path
									d="M296.365 137.625C298.657 121.18 287.184 107.849 270.739 107.849H300.515H390.862C407.307 107.849 418.78 121.18 416.488 137.625H296.365Z"
									fill="#263238"
								/>
								<path
									opacity="0.7"
									d="M296.365 137.625C298.657 121.18 287.184 107.849 270.739 107.849H300.515H390.862C407.307 107.849 418.78 121.18 416.488 137.625H296.365Z"
									fill="#F19B3D"
								/>
								<path
									d="M270.739 107.849H361.087H390.862C374.418 107.849 359.229 121.18 356.937 137.625L329.783 332.462C327.491 348.907 312.302 362.238 295.858 362.238H235.286C218.841 362.238 207.368 348.907 209.66 332.462L236.814 137.625C239.105 121.18 254.294 107.849 270.739 107.849Z"
									fill="#F19B3D"
								/>
								<path
									d="M270.231 332.462C267.939 348.907 279.412 362.238 295.857 362.238H266.081H175.734C159.289 362.238 147.816 348.907 150.108 332.462H270.231Z"
									fill="#263238"
								/>
								<path
									opacity="0.7"
									d="M270.231 332.462C267.939 348.907 279.412 362.238 295.857 362.238H266.081H175.734C159.289 362.238 147.816 348.907 150.108 332.462H270.231Z"
									fill="#F19B3D"
								/>
								<path
									opacity="0.4"
									d="M289.491 168.462H336.018C337.373 168.462 338.636 167.353 338.825 165.998C339.014 164.643 338.06 163.534 336.704 163.534H290.177C288.822 163.534 287.559 164.643 287.37 165.998C287.182 167.353 288.136 168.462 289.491 168.462Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M288.213 177.633H322.402C323.757 177.633 325.02 176.524 325.209 175.169C325.398 173.814 324.444 172.705 323.088 172.705H288.9C287.545 172.705 286.282 173.814 286.093 175.169C285.903 176.525 286.858 177.633 288.213 177.633Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M268.938 179.103C275.372 173.102 276.355 163.699 271.134 158.102C265.913 152.504 256.465 152.831 250.031 158.832C243.597 164.833 242.614 174.236 247.835 179.833C253.056 185.431 262.504 185.104 268.938 179.103Z"
									fill="white"
								/>
								<path
									d="M246.208 168.963C245.889 171.254 246.17 173.405 246.931 175.282C248.592 179.417 252.582 182.229 257.626 182.229C262.669 182.229 267.443 179.417 270.257 175.282C271.541 173.405 272.421 171.254 272.741 168.963C273.762 161.635 268.651 155.697 261.324 155.697C253.995 155.697 247.229 161.635 246.208 168.963Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M249.819 174.033C251.094 177.205 254.155 179.363 258.024 179.363C261.893 179.363 265.556 177.205 267.715 174.033C265.391 172.321 262.455 171.322 259.145 171.322C255.835 171.322 252.62 172.321 249.819 174.033Z"
									fill="#263238"
								/>
								<path
									opacity="0.4"
									d="M255.394 165.702C255.045 168.206 256.792 170.236 259.296 170.236C261.8 170.236 264.113 168.206 264.462 165.702C264.811 163.198 263.064 161.168 260.56 161.168C258.056 161.168 255.743 163.198 255.394 165.702Z"
									fill="#263238"
								/>
								<path
									opacity="0.4"
									d="M283.906 208.534H299.602C300.957 208.534 302.22 207.425 302.409 206.07C302.598 204.715 301.644 203.606 300.289 203.606H284.593C283.238 203.606 281.975 204.715 281.786 206.07C281.597 207.425 282.551 208.534 283.906 208.534Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M309.073 208.534H331.494C332.849 208.534 334.112 207.425 334.301 206.07C334.49 204.715 333.536 203.606 332.18 203.606H309.76C308.405 203.606 307.142 204.715 306.953 206.07C306.763 207.425 307.718 208.534 309.073 208.534Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M282.628 217.705H321.063C322.418 217.705 323.681 216.596 323.87 215.241C324.059 213.886 323.105 212.777 321.749 212.777H283.314C281.959 212.777 280.696 213.886 280.507 215.241C280.319 216.596 281.273 217.705 282.628 217.705Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M263.353 219.171C269.787 213.17 270.77 203.767 265.549 198.17C260.328 192.572 250.88 192.9 244.446 198.901C238.013 204.902 237.029 214.304 242.25 219.902C247.471 225.499 256.919 225.172 263.353 219.171Z"
									fill="white"
								/>
								<path
									d="M240.623 209.035C240.304 211.326 240.585 213.477 241.346 215.354C243.007 219.489 246.998 222.301 252.041 222.301C257.084 222.301 261.858 219.489 264.672 215.354C265.956 213.477 266.836 211.326 267.156 209.035C268.177 201.707 263.067 195.769 255.739 195.769C248.41 195.769 241.644 201.707 240.623 209.035Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M244.234 214.104C245.509 217.276 248.57 219.434 252.439 219.434C256.308 219.434 259.971 217.276 262.13 214.104C259.806 212.392 256.87 211.393 253.559 211.393C250.25 211.393 247.036 212.393 244.234 214.104Z"
									fill="#263238"
								/>
								<path
									opacity="0.4"
									d="M249.81 205.774C249.461 208.278 251.208 210.308 253.712 210.308C256.216 210.308 258.529 208.278 258.878 205.774C259.227 203.27 257.48 201.24 254.976 201.24C252.472 201.24 250.159 203.27 249.81 205.774Z"
									fill="#263238"
								/>
								<path
									opacity="0.4"
									d="M278.322 248.605H305.651C307.006 248.605 308.269 247.496 308.458 246.141C308.647 244.786 307.693 243.677 306.338 243.677H279.009C277.654 243.677 276.391 244.786 276.202 246.141C276.012 247.496 276.966 248.605 278.322 248.605Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M277.043 257.777H319.647C321.002 257.777 322.265 256.668 322.454 255.313C322.643 253.958 321.689 252.849 320.333 252.849H277.73C276.375 252.849 275.112 253.958 274.923 255.313C274.734 256.668 275.688 257.777 277.043 257.777Z"
									fill="white"
								/>
								<path
									opacity="0.2"
									d="M230.39 296.819H295.632C297.532 296.819 299.304 295.264 299.568 293.364C299.833 291.464 298.495 289.909 296.595 289.909H231.353C229.453 289.909 227.681 291.464 227.417 293.364C227.152 295.264 228.49 296.819 230.39 296.819Z"
									fill="white"
								/>
								<path
									opacity="0.2"
									d="M228.598 309.68H276.538C278.438 309.68 280.21 308.125 280.474 306.225C280.739 304.325 279.401 302.77 277.5 302.77H229.56C227.66 302.77 225.888 304.325 225.624 306.225C225.36 308.125 226.698 309.68 228.598 309.68Z"
									fill="white"
								/>
								<path
									opacity="0.2"
									d="M253.072 139.412H330.856C331.839 139.412 332.755 138.608 332.892 137.625C333.029 136.642 332.337 135.838 331.354 135.838H253.57C252.587 135.838 251.671 136.642 251.534 137.625C251.397 138.608 252.089 139.412 253.072 139.412Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M257.768 259.248C264.202 253.247 265.185 243.845 259.965 238.247C254.744 232.65 245.296 232.977 238.862 238.978C232.428 244.979 231.445 254.382 236.665 259.979C241.886 265.577 251.334 265.249 257.768 259.248Z"
									fill="white"
								/>
								<path
									d="M235.038 249.107C234.719 251.398 235 253.549 235.76 255.426C237.421 259.561 241.411 262.373 246.455 262.373C251.498 262.373 256.272 259.561 259.086 255.426C260.37 253.549 261.25 251.398 261.57 249.107C262.591 241.779 257.481 235.841 250.153 235.841C242.826 235.84 236.06 241.779 235.038 249.107Z"
									fill="white"
								/>
								<path
									opacity="0.4"
									d="M238.65 254.176C239.925 257.348 242.986 259.506 246.856 259.506C250.726 259.506 254.388 257.348 256.547 254.176C254.223 252.464 251.287 251.465 247.977 251.465C244.665 251.465 241.451 252.464 238.65 254.176Z"
									fill="#263238"
								/>
								<path
									opacity="0.4"
									d="M244.225 245.846C243.876 248.35 245.623 250.38 248.127 250.38C250.631 250.38 252.944 248.35 253.293 245.846C253.642 243.342 251.895 241.312 249.391 241.312C246.887 241.312 244.574 243.342 244.225 245.846Z"
									fill="#263238"
								/>
							</svg>

							<p className="m-auto w-full text-center text-[14px] my-[2rem]">
								Search for contacts using the search bar above.
							</p>
						</div>
					)}
					{contacts && <List contacts={contacts} />}
					{!contacts && contacts !== null && (
						<div className="py-[3rem]">
							{newUser && (
								<svg
									className="w-full md:w-[20rem] mx-auto"
									viewBox="0 0 500 374"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M500 328.398H0V328.648H500V328.398Z"
										fill="#EBEBEB"
									/>
									<path
										d="M449.901 344.494H416.779V344.744H449.901V344.494Z"
										fill="#EBEBEB"
									/>
									<path
										d="M331.22 347.208H322.527V347.458H331.22V347.208Z"
										fill="#EBEBEB"
									/>
									<path
										d="M415.778 335.208H396.586V335.458H415.778V335.208Z"
										fill="#EBEBEB"
									/>
									<path
										d="M95.652 336.888H52.459V337.138H95.652V336.888Z"
										fill="#EBEBEB"
									/>
									<path
										d="M110.889 336.888H104.556V337.138H110.889V336.888Z"
										fill="#EBEBEB"
									/>
									<path
										d="M225.147 341.111H131.471V341.361H225.147V341.111Z"
										fill="#EBEBEB"
									/>
									<path
										d="M237.014 283.8H43.915C40.768 283.8 38.207 281.239 38.207 278.092V6.66C38.207 3.513 40.768 0.951996 43.915 0.951996H237.014C240.16 0.951996 242.721 3.513 242.721 6.66V278.092C242.721 281.239 240.16 283.8 237.014 283.8ZM43.915 1.203C40.905 1.203 38.457 3.651 38.457 6.661V278.093C38.457 281.103 40.905 283.551 43.915 283.551H237.014C240.023 283.551 242.471 281.103 242.471 278.093V6.66C242.471 3.651 240.023 1.202 237.014 1.202L43.915 1.203Z"
										fill="#EBEBEB"
									/>
									<path
										d="M453.31 283.8H260.212C257.065 283.8 254.505 281.239 254.505 278.092V6.66C254.505 3.513 257.066 0.951996 260.212 0.951996H453.31C456.458 0.951996 459.018 3.513 459.018 6.66V278.092C459.019 281.239 456.458 283.8 453.31 283.8ZM260.212 1.203C257.203 1.203 254.755 3.651 254.755 6.661V278.093C254.755 281.103 257.203 283.551 260.212 283.551H453.31C456.32 283.551 458.768 281.103 458.768 278.093V6.66C458.768 3.651 456.32 1.202 453.31 1.202L260.212 1.203Z"
										fill="#EBEBEB"
									/>
									<path
										d="M54.9741 328.397H82.1621L82.1621 255.955H54.9741L54.9741 328.397Z"
										fill="#E6E6E6"
									/>
									<path
										d="M60.1381 328.398H54.9741V309.254H65.5521L60.1381 328.398Z"
										fill="#F0F0F0"
									/>
									<path
										d="M210.102 328.397H237.29V255.955H210.102V328.397Z"
										fill="#E6E6E6"
									/>
									<path
										d="M54.9736 323.173H214.609V255.956H54.9736V323.173Z"
										fill="#F0F0F0"
									/>
									<path
										d="M209.445 328.398H214.609V309.254H204.03L209.445 328.398Z"
										fill="#F0F0F0"
									/>
									<path
										d="M209.8 315.08H161.48V263.364H209.8V315.08ZM162.48 314.08H208.8V264.364H162.48V314.08Z"
										fill="#E6E6E6"
									/>
									<path
										d="M158.951 315.08H110.631V263.364H158.951V315.08ZM111.631 314.08H157.951V264.364H111.631V314.08Z"
										fill="#E6E6E6"
									/>
									<path
										d="M108.103 315.08H59.781V263.364H108.102L108.103 315.08ZM60.781 314.08H107.102V264.364H60.781V314.08Z"
										fill="#E6E6E6"
									/>
									<path
										d="M271.464 177.659L431.67 177.659V41.2502L271.464 41.2502V177.659Z"
										fill="#E6E6E6"
									/>
									<path
										d="M267.859 177.659L430.104 177.659V41.2502L267.859 41.2502V177.659Z"
										fill="#F5F5F5"
									/>
									<path
										d="M423.631 171.113V47.7973L274.33 47.7973V171.113L423.631 171.113Z"
										fill="#FAFAFA"
									/>
									<path
										d="M405.311 171.113L346.55 47.797H326.591L385.352 171.113H405.311Z"
										fill="white"
									/>
									<path
										d="M379.695 171.113L320.933 47.797H307.19L365.951 171.113H379.695Z"
										fill="white"
									/>
									<path
										d="M329.768 171.113V47.7969H322.047V171.113H329.768Z"
										fill="#E6E6E6"
									/>
									<path
										d="M381.087 171.112V47.7965H373.366V171.112H381.087Z"
										fill="#E6E6E6"
									/>
									<path
										d="M328.375 175.267V42.9297H318.616V175.267H328.375Z"
										fill="#F5F5F5"
									/>
									<path
										d="M379.694 175.266V42.9293H369.935V175.266H379.694Z"
										fill="#F5F5F5"
									/>
									<path
										d="M275.017 171.113V47.7974H274.33V171.113H275.017Z"
										fill="#E6E6E6"
									/>
									<path
										d="M265.141 32.832H438.706C439.165 32.832 439.541 33.208 439.541 33.667C439.541 34.126 439.165 34.502 438.706 34.502H265.141C264.682 34.502 264.306 34.126 264.306 33.667C264.306 33.208 264.682 32.832 265.141 32.832Z"
										fill="#E6E6E6"
									/>
									<path
										d="M431.67 38.341C432.29 38.341 432.797 37.834 432.797 37.214V34.794C432.797 34.174 432.29 33.667 431.67 33.667C431.05 33.667 430.543 34.174 430.543 34.794V37.214C430.543 37.834 431.05 38.341 431.67 38.341Z"
										fill="#E6E6E6"
									/>
									<path
										d="M277.728 38.341C278.348 38.341 278.855 37.834 278.855 37.214V34.794C278.855 34.174 278.348 33.667 277.728 33.667C277.108 33.667 276.601 34.174 276.601 34.794V37.214C276.601 37.834 277.108 38.341 277.728 38.341Z"
										fill="#E6E6E6"
									/>
									<path
										opacity="0.6"
										d="M265.408 101.369L427.534 101.369V33.6668L265.408 33.6668V101.369Z"
										fill="#E0E0E0"
									/>
									<path
										d="M113.245 255.956H90.5721C88.1611 255.956 86.2061 254.001 86.2061 251.59V212.418C86.2061 210.007 88.1611 208.052 90.5721 208.052H113.245C115.656 208.052 117.611 210.007 117.611 212.418V251.59C117.611 254.001 115.657 255.956 113.245 255.956Z"
										fill="#FAFAFA"
									/>
									<path
										d="M116.146 208.617H87.6721C86.8621 208.617 86.2061 207.961 86.2061 207.151V205.965C86.2061 205.155 86.8621 204.499 87.6721 204.499H116.146C116.956 204.499 117.612 205.155 117.612 205.965V207.151C117.611 207.961 116.955 208.617 116.146 208.617Z"
										fill="#E6E6E6"
									/>
									<path
										d="M199.331 255.956H182.875C181.125 255.956 179.706 254.537 179.706 252.787V224.356C179.706 222.606 181.125 221.187 182.875 221.187H199.331C201.081 221.187 202.5 222.606 202.5 224.356V252.787C202.5 254.537 201.081 255.956 199.331 255.956Z"
										fill="#F0F0F0"
									/>
									<path
										d="M201.436 221.598H180.77C180.183 221.598 179.706 221.122 179.706 220.534V219.673C179.706 219.085 180.182 218.609 180.77 218.609H201.436C202.024 218.609 202.5 219.085 202.5 219.673V220.534C202.5 221.121 202.024 221.598 201.436 221.598Z"
										fill="#E6E6E6"
									/>
									<path
										d="M147.122 255.956H115.964C112.65 255.956 109.964 253.27 109.964 249.956V234.021C109.964 230.707 112.65 228.021 115.964 228.021H147.122C150.436 228.021 153.122 230.707 153.122 234.021V249.956C153.122 253.269 150.436 255.956 147.122 255.956Z"
										fill="#F0F0F0"
									/>
									<path
										d="M151.108 228.799H111.978C110.865 228.799 109.964 227.897 109.964 226.785V225.156C109.964 224.043 110.866 223.142 111.978 223.142H151.108C152.221 223.142 153.122 224.044 153.122 225.156V226.785C153.122 227.897 152.22 228.799 151.108 228.799Z"
										fill="#F5F5F5"
									/>
									<path
										d="M282.435 328.398H287.473V245.755H282.435V328.398Z"
										fill="#E6E6E6"
									/>
									<path
										d="M427.956 229.672H400.666V245.755H427.956V229.672Z"
										fill="#E6E6E6"
									/>
									<path
										d="M264.986 245.755L400.667 245.755V229.672L264.986 229.672V245.755Z"
										fill="#F5F5F5"
									/>
									<path
										d="M427.956 272.618H400.666V288.701H427.956V272.618Z"
										fill="#E6E6E6"
									/>
									<path
										d="M264.986 288.702H400.667V272.619H264.986V288.702Z"
										fill="#F5F5F5"
									/>
									<path
										d="M418.116 328.398H423.154V245.755H418.116V328.398Z"
										fill="#E6E6E6"
									/>
									<path
										d="M395.629 328.398H400.667V245.755H395.629V328.398Z"
										fill="#F5F5F5"
									/>
									<path
										d="M264.986 328.398H270.024V245.755H264.986V328.398Z"
										fill="#F5F5F5"
									/>
									<path
										d="M69.6786 120.035L133.821 120.035V48.101L69.6786 48.101L69.6786 120.035Z"
										fill="#F0F0F0"
									/>
									<path
										d="M65.156 120.035L132.822 120.035V48.101L65.156 48.101L65.156 120.035Z"
										fill="#F5F5F5"
									/>
									<path
										d="M70.8247 53.7695V114.367H127.154V53.7695H70.8247Z"
										fill="white"
									/>
									<path
										d="M89.6481 66.599C85.2111 66.599 80.9951 69.203 79.1761 73.522C76.7651 79.246 79.4871 85.917 85.2251 88.328L127.158 105.974V81.421L93.9971 67.473C92.5761 66.88 91.0971 66.599 89.6481 66.599Z"
										fill="#F0F0F0"
									/>
									<path
										d="M154.858 156.002H219V84.068L154.858 84.068V156.002Z"
										fill="#F0F0F0"
									/>
									<path
										d="M150.336 156.002H218.002V84.068L150.336 84.068V156.002Z"
										fill="#F5F5F5"
									/>
									<path
										d="M156.003 89.7362V150.333H212.332V89.7362H156.003Z"
										fill="white"
									/>
									<path
										d="M190.509 113.165L156.006 98.646V123.778L181.531 134.512C187.406 136.98 194.233 134.194 196.701 128.32C199.169 122.461 196.383 115.633 190.509 113.165Z"
										fill="#F0F0F0"
									/>
									<path
										d="M250 373.561C357.082 373.561 443.889 368.492 443.889 362.238C443.889 355.984 357.082 350.915 250 350.915C142.918 350.915 56.1111 355.984 56.1111 362.238C56.1111 368.492 142.918 373.561 250 373.561Z"
										fill="#F5F5F5"
									/>
									<path
										d="M194.071 62.206C195.03 58 205.53 54 214.53 60.167C223.53 66.334 225.914 76.915 223.03 85.449C218.197 99.75 243.413 99.221 249.251 123.333C253.861 142.376 249.585 169.242 223.86 167.781C184.59 165.551 187.981 127.166 186.255 107C184.53 86.833 163.112 64.245 194.071 62.206Z"
										fill="#263238"
									/>
									<path
										d="M181.097 116.059C180.931 118.978 180.588 121.652 180.205 124.424C179.814 127.172 179.299 129.9 178.704 132.621C178.096 135.339 177.452 138.057 176.594 140.738C175.781 143.426 174.817 146.094 173.678 148.716L172.796 150.676C172.672 150.974 172.434 151.408 172.245 151.776C172.044 152.156 171.829 152.49 171.62 152.846C170.769 154.214 169.832 155.382 168.883 156.497C166.984 158.72 164.957 160.666 162.885 162.522C158.693 166.189 154.375 169.489 149.729 172.482L147.055 169.031C148.939 167.207 150.855 165.327 152.709 163.448C154.58 161.58 156.393 159.663 158.128 157.721C159.873 155.794 161.534 153.813 162.981 151.827C163.699 150.835 164.345 149.823 164.857 148.873C164.969 148.64 165.106 148.399 165.201 148.176C165.298 147.935 165.385 147.779 165.503 147.45L166.175 145.69C167.913 140.961 169.146 135.935 170.152 130.858C170.663 128.317 171.026 125.738 171.41 123.167C171.781 120.617 172.074 117.95 172.299 115.506L181.097 116.059Z"
										fill="#BE8A5C"
									/>
									<path
										d="M175.098 105.555C171.546 106.459 169.061 121.078 169.061 121.078L182.647 130.317C182.647 130.317 188.236 112.987 185.503 109.082C182.657 105.015 180.282 104.235 175.098 105.555Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.2"
										d="M175.419 108.82L172.69 123.555L178.192 127.286L175.419 108.82Z"
										fill="black"
									/>
									<path
										d="M148.68 167.781L139.528 169.242L144.745 175.024C144.745 175.024 150.14 173.791 151.086 170.335L148.68 167.781Z"
										fill="#BE8A5C"
									/>
									<path
										d="M135.199 170.387L140.419 176.041L144.745 175.025L139.528 169.242L135.199 170.387Z"
										fill="#BE8A5C"
									/>
									<path
										d="M194.317 351.604H185.698L185.123 331.644H193.742L194.317 351.604Z"
										fill="#BE8A5C"
									/>
									<path
										d="M253.922 326.202L245.943 329.46L235.833 312.028L243.813 308.77L253.922 326.202Z"
										fill="#BE8A5C"
									/>
									<path
										d="M244.44 328.264L252.764 323.317C253.067 323.137 253.438 323.201 253.656 323.472L258.518 329.495C259.022 330.12 258.819 331.115 258.113 331.518C255.181 333.193 253.681 333.853 250.02 336.029C247.768 337.367 242.473 341.953 239.363 343.801C236.321 345.608 234.26 342.672 235.389 341.624C240.454 336.925 242.491 332.26 243.471 329.455C243.649 328.949 243.997 328.527 244.44 328.264Z"
										fill="#263238"
									/>
									<path
										d="M185.403 350.606H195.086C195.438 350.606 195.724 350.851 195.774 351.195L196.877 358.856C196.991 359.651 196.308 360.403 195.495 360.389C192.119 360.331 190.492 360.133 186.234 360.133C183.614 360.133 178.195 360.405 174.578 360.405C171.04 360.405 170.767 356.828 172.274 356.504C179.029 355.051 181.687 353.048 183.962 351.137C184.373 350.792 184.887 350.606 185.403 350.606Z"
										fill="#263238"
									/>
									<g opacity="0.2">
										<path
											d="M185.125 331.65L185.42 341.938H194.042L193.747 331.65H185.125Z"
											fill="black"
										/>
										<path
											d="M243.817 308.774L235.834 312.033L241.049 321.017L249.032 317.758L243.817 308.774Z"
											fill="black"
										/>
									</g>
									<path
										d="M175.098 105.555C175.098 105.555 170.992 107.001 179.217 157.575C193.107 157.575 207.463 157.575 214.222 157.575C213.635 143.328 213.618 134.543 220.427 105.305C220.427 105.305 213.093 103.71 205.562 103.347C199.671 103.063 194.845 102.875 189.667 103.348C182.84 103.971 175.098 105.555 175.098 105.555Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.2"
										d="M217.54 116.88C214.37 117.67 211.44 121.13 211.79 127.5C212 131.32 213.75 134.21 214.71 135.52C215.27 130.62 216.21 124.93 217.7 117.65L217.54 116.88Z"
										fill="black"
									/>
									<path
										d="M191.51 117.333C191.51 117.333 196.058 120.139 197.251 124.305C202.187 120.688 208.901 110.616 209.167 104.591C209.199 103.858 208.577 103.265 207.843 103.254C206.408 103.232 205.564 103.347 205.564 103.347L191.51 117.333Z"
										fill="#FAFAFA"
									/>
									<path
										d="M191.51 117.333C191.51 117.333 186.962 120.139 185.77 124.305C180.463 120.416 183.407 107.583 186.447 103.308C188.641 103.165 189.668 103.347 189.668 103.347L191.51 117.333Z"
										fill="#FAFAFA"
									/>
									<path
										d="M203.988 85.449C202.985 90.564 201.985 99.934 205.563 103.347C205.563 103.347 200.836 112.417 191.51 117.333C184.419 111.666 189.668 103.347 189.668 103.347C195.371 101.985 195.224 97.754 194.231 93.78L203.988 85.449Z"
										fill="#BE8A5C"
									/>
									<path
										opacity="0.2"
										d="M200.01 88.848L194.235 93.776C194.473 94.717 194.659 95.67 194.725 96.597C196.904 96.282 200.33 94.426 200.798 92.057C201.019 90.935 200.195 89.378 200.01 88.848Z"
										fill="black"
									/>
									<path
										d="M212.562 77.234C210.197 85.455 209.372 88.985 204.212 92.327C196.45 97.354 186.869 92.652 186.73 83.891C186.605 76.005 190.492 63.886 199.388 62.383C208.152 60.901 214.927 69.013 212.562 77.234Z"
										fill="#BE8A5C"
									/>
									<path
										d="M194.808 63.111C195.197 65.889 210.419 74.833 213.308 70.167C216.197 65.5 212.04 62 205.563 61.111C199.086 60.222 194.808 63.111 194.808 63.111Z"
										fill="#263238"
									/>
									<path
										d="M204.725 64.616C202.855 67.082 206.815 84.796 212.488 83.131C218.161 81.467 217.897 75.794 213.957 70.561C210.016 65.327 204.725 64.616 204.725 64.616Z"
										fill="#263238"
									/>
									<path
										d="M179.217 157.576C179.217 157.576 172.419 223.97 172.983 250.254C173.571 277.593 183.589 339.946 183.589 339.946H195.244C195.244 339.946 193.4 279.191 194.43 252.341C195.553 223.07 204.851 157.576 204.851 157.576H179.217Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M179.217 157.576C179.217 157.576 172.419 223.97 172.983 250.254C173.571 277.593 183.589 339.946 183.589 339.946H195.244C195.244 339.946 193.4 279.191 194.43 252.341C195.553 223.07 204.851 157.576 204.851 157.576H179.217Z"
										fill="black"
									/>
									<path
										d="M196.254 340.363H182.579L181.576 336.001L196.89 335.468L196.254 340.363Z"
										fill="#263238"
									/>
									<path
										opacity="0.2"
										d="M194.316 174.095C185.718 191.391 192.59 222.943 195.63 234.681C197.189 217.051 199.818 195.501 201.867 179.675C200.564 170.721 198.281 166.121 194.316 174.095Z"
										fill="black"
									/>
									<path
										d="M188.461 157.576C188.461 157.576 196.391 226.601 202.379 248.761C209.489 275.07 238.369 319.959 238.369 319.959L249.251 315.517C249.251 315.517 230.6 264.406 225.165 250.546C213.564 220.964 223.494 176.88 214.223 157.576H188.461Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M188.461 157.576C188.461 157.576 196.391 226.601 202.379 248.761C209.489 275.07 238.369 319.959 238.369 319.959L249.251 315.517C249.251 315.517 230.6 264.406 225.165 250.546C213.564 220.964 223.494 176.88 214.223 157.576H188.461Z"
										fill="black"
									/>
									<path
										d="M250.737 315.574L237.237 321.085L234.067 317.428L249.655 310.229L250.737 315.574Z"
										fill="#263238"
									/>
									<path
										d="M91.61 69.761C67.293 91.282 65.031 128.448 86.553 152.765C108.074 177.082 145.234 179.349 169.551 157.827C193.868 136.306 196.14 99.141 174.619 74.824C153.098 50.507 115.927 48.24 91.61 69.761ZM163.385 150.86C142.917 168.975 111.636 167.066 93.521 146.599C75.402 126.126 77.309 94.844 97.777 76.73C118.25 58.61 149.532 60.518 167.651 80.992C185.766 101.458 183.858 132.74 163.385 150.86Z"
										fill="#263238"
									/>
									<path
										opacity="0.3"
										d="M127.819 159.066C102.818 157.541 83.784 136.035 85.309 111.034C86.834 86.026 108.341 66.992 133.342 68.517C158.35 70.042 177.384 91.549 175.858 116.557C174.334 141.558 152.827 160.592 127.819 159.066Z"
										fill="#F19B3D"
									/>
									<g opacity="0.5">
										<path
											d="M133.341 68.52C133.055 68.502 132.776 68.485 132.489 68.476L85.3711 110.176C85.3461 110.462 85.3281 110.748 85.3111 111.035C84.6881 121.259 87.5101 130.9 92.7671 138.834L160.036 79.299C152.808 73.117 143.573 69.144 133.341 68.52Z"
											fill="#FAFAFA"
										/>
										<path
											d="M164.391 83.557L96.4651 143.673C98.7311 146.266 101.292 148.597 104.105 150.618L170.355 91.984C168.692 88.947 166.689 86.121 164.391 83.557Z"
											fill="#FAFAFA"
										/>
									</g>
									<path
										d="M176.85 158.271L169.11 165.121C167.934 166.162 166.137 166.052 165.097 164.876C164.056 163.7 164.166 161.903 165.342 160.863L173.082 154.013C174.258 152.972 176.055 153.082 177.095 154.258C178.135 155.433 178.026 157.23 176.85 158.271Z"
										fill="#263238"
									/>
									<path
										d="M173.999 156.997C179.833 162.13 185.413 167.489 190.917 172.915C196.416 178.345 201.807 183.87 207.129 189.457C212.445 195.049 217.674 200.719 222.851 206.433C227.709 212.43 234.332 216.865 235.322 226.287C235.597 228.903 233.699 231.246 231.083 231.521C230.551 231.577 230.01 231.537 229.516 231.426C220.285 229.298 216.687 222.185 211.325 216.634C206.282 210.8 201.29 204.922 196.385 198.965C191.486 193.004 186.657 186.981 181.936 180.863C177.219 174.74 172.578 168.551 168.192 162.136C166.974 160.355 167.431 157.923 169.212 156.705C170.718 155.676 172.689 155.846 173.999 156.997Z"
										fill="#263238"
									/>
									<path
										d="M198.778 76.493C198.627 77.172 198.145 77.642 197.702 77.543C197.258 77.444 197.021 76.814 197.172 76.136C197.323 75.457 197.805 74.987 198.248 75.086C198.692 75.184 198.929 75.814 198.778 76.493Z"
										fill="#263238"
									/>
									<path
										d="M191.108 74.787C190.957 75.466 190.475 75.936 190.032 75.837C189.588 75.738 189.351 75.108 189.502 74.43C189.653 73.751 190.135 73.281 190.578 73.38C191.021 73.479 191.258 74.109 191.108 74.787Z"
										fill="#263238"
									/>
									<path
										d="M190.765 73.461L189.239 72.629C189.239 72.629 189.793 74.088 190.765 73.461Z"
										fill="#263238"
									/>
									<path
										d="M193.201 76.536C193.201 76.536 191.4 79.202 189.819 80.329C190.529 81.364 192.137 81.321 192.137 81.321L193.201 76.536Z"
										fill="#B67647"
									/>
									<path
										d="M195.248 84.801C194.925 84.78 194.586 84.733 194.232 84.654C194.122 84.63 194.052 84.521 194.076 84.411C194.101 84.3 194.211 84.226 194.32 84.256C197.301 84.913 199.152 83.146 199.17 83.128C199.251 83.049 199.38 83.05 199.459 83.131C199.538 83.211 199.536 83.341 199.456 83.42C199.383 83.491 197.834 84.972 195.248 84.801Z"
										fill="#263238"
									/>
									<path
										d="M213.108 85.435C212.126 86.911 210.553 87.796 209.12 88.06C206.964 88.457 206.083 86.481 206.847 84.55C207.535 82.812 209.486 80.51 211.57 80.988C213.624 81.458 214.231 83.747 213.108 85.435Z"
										fill="#BE8A5C"
									/>
									<path
										d="M201.973 73.496C201.809 73.549 201.623 73.495 201.517 73.348C200.407 71.82 197.974 71.837 197.95 71.837C197.725 71.84 197.539 71.66 197.536 71.435C197.532 71.21 197.71 71.024 197.938 71.021C198.055 71.019 200.82 71.002 202.178 72.868C202.31 73.05 202.27 73.306 202.088 73.438C202.052 73.464 202.013 73.483 201.973 73.496Z"
										fill="#263238"
									/>
									<path
										d="M189.511 69.169C189.372 69.16 189.241 69.08 189.173 68.947C189.071 68.746 189.151 68.501 189.352 68.398C191.364 67.374 193.01 68.296 193.078 68.336C193.274 68.449 193.341 68.698 193.228 68.894C193.116 69.089 192.868 69.155 192.671 69.045C192.605 69.008 191.32 68.313 189.722 69.127C189.655 69.159 189.582 69.173 189.511 69.169Z"
										fill="#263238"
									/>
									<path
										d="M241.133 331.534C241.099 331.53 241.065 331.525 241.031 331.518C240.648 331.439 240.364 331.184 240.186 330.758C240.052 330.437 240.142 330.2 240.242 330.058C240.872 329.156 243.986 329.271 244.338 329.287C244.426 329.289 244.491 329.343 244.52 329.419C244.549 329.495 244.53 329.581 244.471 329.638C243.673 330.409 242.2 331.658 241.133 331.534ZM243.826 329.681C242.58 329.672 240.909 329.816 240.577 330.291C240.535 330.351 240.496 330.44 240.563 330.6C240.687 330.897 240.868 331.067 241.114 331.117C241.696 331.247 242.689 330.705 243.826 329.681Z"
										fill="#F19B3D"
									/>
									<path
										d="M244.016 329.676C242.952 329.553 241.06 328.822 240.763 327.98C240.7 327.801 240.655 327.454 241.063 327.14C241.322 326.941 241.618 326.873 241.945 326.933C243.174 327.168 244.452 329.295 244.506 329.386C244.543 329.449 244.544 329.526 244.509 329.59C244.474 329.653 244.408 329.693 244.335 329.695C244.24 329.696 244.133 329.69 244.016 329.676ZM241.807 327.325C241.623 327.304 241.461 327.349 241.312 327.464C241.104 327.625 241.115 327.752 241.148 327.846C241.348 328.415 242.902 329.117 243.941 329.261C243.478 328.575 242.601 327.475 241.868 327.335C241.847 327.33 241.826 327.327 241.807 327.325Z"
										fill="#F19B3D"
									/>
									<path
										d="M182.167 352.113C181.31 352.113 180.519 351.98 180.076 351.582C179.795 351.329 179.671 350.995 179.708 350.588C179.73 350.345 179.85 350.157 180.054 350.046C181.112 349.464 184.546 351.222 184.934 351.424C185.011 351.464 185.054 351.548 185.042 351.634C185.03 351.72 184.965 351.789 184.88 351.806C184.147 351.95 183.116 352.113 182.167 352.113ZM180.631 350.329C180.473 350.329 180.343 350.352 180.25 350.403C180.166 350.449 180.124 350.517 180.115 350.624C180.09 350.9 180.167 351.113 180.349 351.277C180.872 351.748 182.29 351.83 184.201 351.512C183.018 350.946 181.447 350.329 180.631 350.329Z"
										fill="#F19B3D"
									/>
									<path
										d="M184.84 351.809C184.811 351.809 184.783 351.803 184.756 351.791C183.729 351.327 181.697 349.468 181.856 348.491C181.894 348.26 182.057 347.972 182.623 347.915C183.038 347.871 183.422 347.991 183.754 348.268C184.837 349.17 185.036 351.491 185.044 351.589C185.05 351.661 185.017 351.731 184.958 351.773C184.923 351.796 184.881 351.809 184.84 351.809ZM182.786 348.315C182.746 348.315 182.705 348.317 182.663 348.321C182.29 348.359 182.266 348.508 182.258 348.557C182.162 349.143 183.542 350.605 184.589 351.24C184.488 350.565 184.202 349.173 183.491 348.581C183.277 348.402 183.045 348.315 182.786 348.315Z"
										fill="#F19B3D"
									/>
									<path
										d="M198.436 75.166L196.91 74.334C196.91 74.334 197.464 75.793 198.436 75.166Z"
										fill="#263238"
									/>
									<path
										d="M214.746 155.521L215.641 158.654C215.763 158.897 215.476 159.145 215.071 159.145H179.044C178.728 159.145 178.467 158.99 178.447 158.792L178.131 155.659C178.109 155.442 178.383 155.258 178.728 155.258H214.176C214.437 155.258 214.667 155.365 214.746 155.521Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.2"
										d="M214.746 155.521L215.641 158.654C215.763 158.897 215.476 159.145 215.071 159.145H179.044C178.728 159.145 178.467 158.99 178.447 158.792L178.131 155.659C178.109 155.442 178.383 155.258 178.728 155.258H214.176C214.437 155.258 214.667 155.365 214.746 155.521Z"
										fill="black"
									/>
									<path
										d="M209.869 159.485H210.818C211.007 159.485 211.151 159.387 211.138 159.268L210.693 155.197C210.68 155.078 210.515 154.98 210.326 154.98H209.377C209.188 154.98 209.044 155.077 209.057 155.197L209.502 159.268C209.514 159.387 209.68 159.485 209.869 159.485Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M209.869 159.485H210.818C211.007 159.485 211.151 159.387 211.138 159.268L210.693 155.197C210.68 155.078 210.515 154.98 210.326 154.98H209.377C209.188 154.98 209.044 155.077 209.057 155.197L209.502 159.268C209.514 159.387 209.68 159.485 209.869 159.485Z"
										fill="white"
									/>
									<path
										d="M181.712 159.485H182.661C182.85 159.485 182.994 159.387 182.981 159.268L182.536 155.197C182.523 155.078 182.358 154.98 182.168 154.98H181.219C181.03 154.98 180.886 155.077 180.899 155.197L181.344 159.268C181.358 159.387 181.523 159.485 181.712 159.485Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M181.712 159.485H182.661C182.85 159.485 182.994 159.387 182.981 159.268L182.536 155.197C182.523 155.078 182.358 154.98 182.168 154.98H181.219C181.03 154.98 180.886 155.077 180.899 155.197L181.344 159.268C181.358 159.387 181.523 159.485 181.712 159.485Z"
										fill="white"
									/>
									<path
										d="M195.732 159.485H196.681C196.87 159.485 197.014 159.387 197.001 159.268L196.556 155.197C196.543 155.078 196.378 154.98 196.189 154.98H195.24C195.051 154.98 194.907 155.077 194.92 155.197L195.365 159.268C195.377 159.387 195.543 159.485 195.732 159.485Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M195.732 159.485H196.681C196.87 159.485 197.014 159.387 197.001 159.268L196.556 155.197C196.543 155.078 196.378 154.98 196.189 154.98H195.24C195.051 154.98 194.907 155.077 194.92 155.197L195.365 159.268C195.377 159.387 195.543 159.485 195.732 159.485Z"
										fill="white"
									/>
									<path
										d="M193.188 164.562L184.687 160.763L187.11 169.186C187.11 169.186 192.507 170.411 194.856 167.705L193.188 164.562Z"
										fill="#BE8A5C"
									/>
									<path
										d="M224.509 115.689C224.903 118.643 225.208 121.606 225.56 124.565L226.464 133.458C226.779 136.42 227.02 139.392 227.298 142.359L227.674 146.814L227.767 147.928C227.778 148.039 227.811 148.505 227.82 148.821C227.831 149.167 227.8 149.513 227.778 149.857C227.631 151.231 227.16 152.463 226.592 153.468C225.427 155.483 223.98 156.753 222.584 157.853C221.171 158.931 219.742 159.796 218.305 160.559C215.418 162.056 212.528 163.236 209.595 164.214C206.668 165.199 203.73 166.037 200.781 166.783C197.807 167.478 194.879 168.131 191.826 168.6L190.856 164.344C193.605 163.442 196.424 162.505 199.15 161.46C201.899 160.459 204.61 159.382 207.233 158.192C209.845 156.991 212.42 155.75 214.712 154.292C215.86 153.577 216.941 152.814 217.847 152.019C218.746 151.237 219.464 150.37 219.735 149.76C219.877 149.458 219.905 149.255 219.901 149.142C219.885 149.114 219.897 149.088 219.886 149.062C219.867 149.006 219.891 149.1 219.851 148.841L219.69 147.734L219.051 143.306C218.653 140.351 218.216 137.401 217.855 134.442L216.729 125.569C216.404 122.606 216.032 119.648 215.749 116.679L224.509 115.689Z"
										fill="#BE8A5C"
									/>
									<path
										d="M220.427 105.305C223.934 106.371 228.146 118.448 228.146 118.448L215.874 131.083C215.874 131.083 209.578 118.095 211.051 113.562C212.587 108.841 216.425 104.089 220.427 105.305Z"
										fill="#F19B3D"
									/>
									<path
										d="M177.655 162.511L180.065 169.454L187.11 169.186L184.687 160.762L177.655 162.511Z"
										fill="#BE8A5C"
									/>
									<path
										d="M296.365 137.625C298.657 121.18 287.184 107.849 270.739 107.849H300.515H390.862C407.307 107.849 418.78 121.18 416.488 137.625H296.365Z"
										fill="#263238"
									/>
									<path
										opacity="0.7"
										d="M296.365 137.625C298.657 121.18 287.184 107.849 270.739 107.849H300.515H390.862C407.307 107.849 418.78 121.18 416.488 137.625H296.365Z"
										fill="#F19B3D"
									/>
									<path
										d="M270.739 107.849H361.087H390.862C374.418 107.849 359.229 121.18 356.937 137.625L329.783 332.462C327.491 348.907 312.302 362.238 295.858 362.238H235.286C218.841 362.238 207.368 348.907 209.66 332.462L236.814 137.625C239.105 121.18 254.294 107.849 270.739 107.849Z"
										fill="#F19B3D"
									/>
									<path
										d="M270.231 332.462C267.939 348.907 279.412 362.238 295.857 362.238H266.081H175.734C159.289 362.238 147.816 348.907 150.108 332.462H270.231Z"
										fill="#263238"
									/>
									<path
										opacity="0.7"
										d="M270.231 332.462C267.939 348.907 279.412 362.238 295.857 362.238H266.081H175.734C159.289 362.238 147.816 348.907 150.108 332.462H270.231Z"
										fill="#F19B3D"
									/>
									<path
										opacity="0.4"
										d="M289.491 168.462H336.018C337.373 168.462 338.636 167.353 338.825 165.998C339.014 164.643 338.06 163.534 336.704 163.534H290.177C288.822 163.534 287.559 164.643 287.37 165.998C287.182 167.353 288.136 168.462 289.491 168.462Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M288.213 177.633H322.402C323.757 177.633 325.02 176.524 325.209 175.169C325.398 173.814 324.444 172.705 323.088 172.705H288.9C287.545 172.705 286.282 173.814 286.093 175.169C285.903 176.525 286.858 177.633 288.213 177.633Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M268.938 179.103C275.372 173.102 276.355 163.699 271.134 158.102C265.913 152.504 256.465 152.831 250.031 158.832C243.597 164.833 242.614 174.236 247.835 179.833C253.056 185.431 262.504 185.104 268.938 179.103Z"
										fill="white"
									/>
									<path
										d="M246.208 168.963C245.889 171.254 246.17 173.405 246.931 175.282C248.592 179.417 252.582 182.229 257.626 182.229C262.669 182.229 267.443 179.417 270.257 175.282C271.541 173.405 272.421 171.254 272.741 168.963C273.762 161.635 268.651 155.697 261.324 155.697C253.995 155.697 247.229 161.635 246.208 168.963Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M249.819 174.033C251.094 177.205 254.155 179.363 258.024 179.363C261.893 179.363 265.556 177.205 267.715 174.033C265.391 172.321 262.455 171.322 259.145 171.322C255.835 171.322 252.62 172.321 249.819 174.033Z"
										fill="#263238"
									/>
									<path
										opacity="0.4"
										d="M255.394 165.702C255.045 168.206 256.792 170.236 259.296 170.236C261.8 170.236 264.113 168.206 264.462 165.702C264.811 163.198 263.064 161.168 260.56 161.168C258.056 161.168 255.743 163.198 255.394 165.702Z"
										fill="#263238"
									/>
									<path
										opacity="0.4"
										d="M283.906 208.534H299.602C300.957 208.534 302.22 207.425 302.409 206.07C302.598 204.715 301.644 203.606 300.289 203.606H284.593C283.238 203.606 281.975 204.715 281.786 206.07C281.597 207.425 282.551 208.534 283.906 208.534Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M309.073 208.534H331.494C332.849 208.534 334.112 207.425 334.301 206.07C334.49 204.715 333.536 203.606 332.18 203.606H309.76C308.405 203.606 307.142 204.715 306.953 206.07C306.763 207.425 307.718 208.534 309.073 208.534Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M282.628 217.705H321.063C322.418 217.705 323.681 216.596 323.87 215.241C324.059 213.886 323.105 212.777 321.749 212.777H283.314C281.959 212.777 280.696 213.886 280.507 215.241C280.319 216.596 281.273 217.705 282.628 217.705Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M263.353 219.171C269.787 213.17 270.77 203.767 265.549 198.17C260.328 192.572 250.88 192.9 244.446 198.901C238.013 204.902 237.029 214.304 242.25 219.902C247.471 225.499 256.919 225.172 263.353 219.171Z"
										fill="white"
									/>
									<path
										d="M240.623 209.035C240.304 211.326 240.585 213.477 241.346 215.354C243.007 219.489 246.998 222.301 252.041 222.301C257.084 222.301 261.858 219.489 264.672 215.354C265.956 213.477 266.836 211.326 267.156 209.035C268.177 201.707 263.067 195.769 255.739 195.769C248.41 195.769 241.644 201.707 240.623 209.035Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M244.234 214.104C245.509 217.276 248.57 219.434 252.439 219.434C256.308 219.434 259.971 217.276 262.13 214.104C259.806 212.392 256.87 211.393 253.559 211.393C250.25 211.393 247.036 212.393 244.234 214.104Z"
										fill="#263238"
									/>
									<path
										opacity="0.4"
										d="M249.81 205.774C249.461 208.278 251.208 210.308 253.712 210.308C256.216 210.308 258.529 208.278 258.878 205.774C259.227 203.27 257.48 201.24 254.976 201.24C252.472 201.24 250.159 203.27 249.81 205.774Z"
										fill="#263238"
									/>
									<path
										opacity="0.4"
										d="M278.322 248.605H305.651C307.006 248.605 308.269 247.496 308.458 246.141C308.647 244.786 307.693 243.677 306.338 243.677H279.009C277.654 243.677 276.391 244.786 276.202 246.141C276.012 247.496 276.966 248.605 278.322 248.605Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M277.043 257.777H319.647C321.002 257.777 322.265 256.668 322.454 255.313C322.643 253.958 321.689 252.849 320.333 252.849H277.73C276.375 252.849 275.112 253.958 274.923 255.313C274.734 256.668 275.688 257.777 277.043 257.777Z"
										fill="white"
									/>
									<path
										opacity="0.2"
										d="M230.39 296.819H295.632C297.532 296.819 299.304 295.264 299.568 293.364C299.833 291.464 298.495 289.909 296.595 289.909H231.353C229.453 289.909 227.681 291.464 227.417 293.364C227.152 295.264 228.49 296.819 230.39 296.819Z"
										fill="white"
									/>
									<path
										opacity="0.2"
										d="M228.598 309.68H276.538C278.438 309.68 280.21 308.125 280.474 306.225C280.739 304.325 279.401 302.77 277.5 302.77H229.56C227.66 302.77 225.888 304.325 225.624 306.225C225.36 308.125 226.698 309.68 228.598 309.68Z"
										fill="white"
									/>
									<path
										opacity="0.2"
										d="M253.072 139.412H330.856C331.839 139.412 332.755 138.608 332.892 137.625C333.029 136.642 332.337 135.838 331.354 135.838H253.57C252.587 135.838 251.671 136.642 251.534 137.625C251.397 138.608 252.089 139.412 253.072 139.412Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M257.768 259.248C264.202 253.247 265.185 243.845 259.965 238.247C254.744 232.65 245.296 232.977 238.862 238.978C232.428 244.979 231.445 254.382 236.665 259.979C241.886 265.577 251.334 265.249 257.768 259.248Z"
										fill="white"
									/>
									<path
										d="M235.038 249.107C234.719 251.398 235 253.549 235.76 255.426C237.421 259.561 241.411 262.373 246.455 262.373C251.498 262.373 256.272 259.561 259.086 255.426C260.37 253.549 261.25 251.398 261.57 249.107C262.591 241.779 257.481 235.841 250.153 235.841C242.826 235.84 236.06 241.779 235.038 249.107Z"
										fill="white"
									/>
									<path
										opacity="0.4"
										d="M238.65 254.176C239.925 257.348 242.986 259.506 246.856 259.506C250.726 259.506 254.388 257.348 256.547 254.176C254.223 252.464 251.287 251.465 247.977 251.465C244.665 251.465 241.451 252.464 238.65 254.176Z"
										fill="#263238"
									/>
									<path
										opacity="0.4"
										d="M244.225 245.846C243.876 248.35 245.623 250.38 248.127 250.38C250.631 250.38 252.944 248.35 253.293 245.846C253.642 243.342 251.895 241.312 249.391 241.312C246.887 241.312 244.574 243.342 244.225 245.846Z"
										fill="#263238"
									/>
								</svg>
							)}
							<p className="m-auto w-full text-center text-[14px] my-[2rem]">
								{phoneError}
							</p>
							{newUser && (
								<button
									// onClick={handleNew}
									onClick={() => setIsOpen(true)}
									className="text-white mx-auto bg-[#f2994a] rounded-[3px] px-[1.5rem] flex h-[32px] text-[14px] mt-[2px]"
								>
									<span className="m-auto flex justify-center gap-[0.2rem]">
										<span className="text-[12px]">
											Register New User
										</span>
										<span>
											<svg
												className="w-[14px]"
												viewBox="0 0 14 14"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M6.41675 1.16669C5.6432 1.16669 4.90133 1.47398 4.35435 2.02096C3.80737 2.56794 3.50008 3.30981 3.50008 4.08335C3.50008 4.8569 3.80737 5.59877 4.35435 6.14575C4.90133 6.69273 5.6432 7.00002 6.41675 7.00002C7.1903 7.00002 7.93216 6.69273 8.47914 6.14575C9.02612 5.59877 9.33342 4.8569 9.33342 4.08335C9.33342 3.30981 9.02612 2.56794 8.47914 2.02096C7.93216 1.47398 7.1903 1.16669 6.41675 1.16669ZM4.66675 4.08335C4.66675 3.85354 4.71201 3.62598 4.79996 3.41366C4.8879 3.20134 5.01681 3.00842 5.17931 2.84592C5.34181 2.68341 5.53473 2.55451 5.74705 2.46656C5.95937 2.37862 6.18694 2.33335 6.41675 2.33335C6.64656 2.33335 6.87412 2.37862 7.08644 2.46656C7.29876 2.55451 7.49168 2.68341 7.65419 2.84592C7.81669 3.00842 7.94559 3.20134 8.03354 3.41366C8.12148 3.62598 8.16675 3.85354 8.16675 4.08335C8.16675 4.54748 7.98237 4.9926 7.65419 5.32079C7.326 5.64898 6.88088 5.83335 6.41675 5.83335C5.95262 5.83335 5.5075 5.64898 5.17931 5.32079C4.85112 4.9926 4.66675 4.54748 4.66675 4.08335ZM2.33341 10.7917C2.33341 10.6867 2.38591 10.5064 2.57433 10.2673C2.75866 10.0339 3.04333 9.78427 3.42075 9.55444C4.175 9.0936 5.23666 8.75002 6.41675 8.75002C6.63569 8.75002 6.85055 8.76149 7.06133 8.78444C7.21527 8.80076 7.36938 8.75526 7.48977 8.65795C7.61016 8.56065 7.68697 8.4195 7.70329 8.26556C7.71961 8.11163 7.67411 7.95751 7.57681 7.83712C7.4795 7.71673 7.33835 7.63993 7.18442 7.6236C6.92937 7.59722 6.67315 7.58378 6.41675 7.58335C5.01966 7.58335 3.748 7.98819 2.81291 8.55869C2.34625 8.84335 1.94725 9.17935 1.65908 9.54452C1.37558 9.90269 1.16675 10.3326 1.16675 10.7917C1.16675 11.2846 1.4065 11.6731 1.75183 11.9502C2.0785 12.2127 2.50958 12.3865 2.9675 12.5079C3.888 12.7511 5.1165 12.8334 6.41675 12.8334L6.81633 12.8304C6.89294 12.8294 6.96859 12.8133 7.03896 12.783C7.10934 12.7527 7.17307 12.7089 7.2265 12.654C7.27994 12.5991 7.32204 12.5342 7.3504 12.4631C7.37876 12.3919 7.39282 12.3158 7.39179 12.2392C7.39076 12.1626 7.37464 12.087 7.34437 12.0166C7.3141 11.9462 7.27027 11.8825 7.21537 11.8291C7.16047 11.7756 7.09558 11.7335 7.02441 11.7052C6.95324 11.6768 6.87719 11.6627 6.80058 11.6638L6.41675 11.6667C5.13925 11.6667 4.035 11.5833 3.26675 11.3797C2.88 11.2776 2.62741 11.1569 2.48216 11.0402C2.355 10.9381 2.33341 10.8629 2.33341 10.7917ZM10.5001 8.16669C10.6548 8.16669 10.8032 8.22815 10.9126 8.33754C11.022 8.44694 11.0834 8.59531 11.0834 8.75002V9.91669H12.2501C12.4048 9.91669 12.5532 9.97815 12.6626 10.0875C12.772 10.1969 12.8334 10.3453 12.8334 10.5C12.8334 10.6547 12.772 10.8031 12.6626 10.9125C12.5532 11.0219 12.4048 11.0834 12.2501 11.0834H11.0834V12.25C11.0834 12.4047 11.022 12.5531 10.9126 12.6625C10.8032 12.7719 10.6548 12.8334 10.5001 12.8334C10.3454 12.8334 10.197 12.7719 10.0876 12.6625C9.97821 12.5531 9.91675 12.4047 9.91675 12.25V11.0834H8.75008C8.59537 11.0834 8.447 11.0219 8.3376 10.9125C8.22821 10.8031 8.16675 10.6547 8.16675 10.5C8.16675 10.3453 8.22821 10.1969 8.3376 10.0875C8.447 9.97815 8.59537 9.91669 8.75008 9.91669H9.91675V8.75002C9.91675 8.59531 9.97821 8.44694 10.0876 8.33754C10.197 8.22815 10.3454 8.16669 10.5001 8.16669Z"
													fill="#ffffff"
												/>
											</svg>
										</span>
									</span>
								</button>
							)}
						</div>
					)}
					{loading && (
						<div className="grid mx-auto">
							<svg
								className="h-[1.88rem] w-[1.5rem] m-auto"
								version="1.1"
								id="loader-1"
								xmlns="http://www.w3.org/2000/svg"
								x="0px"
								y="0px"
								width="2.50rem"
								height="2.50rem"
								viewBox="0 0 40 40"
								enableBackground="new 0 0 40 40"
							>
								<path
									opacity="0.2"
									d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
								/>
								<path
									d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
C22.32,8.481,24.301,9.057,26.013,10.047z"
								>
									<animateTransform
										attributeType="xml"
										attributeName="transform"
										type="rotate"
										from="0 20 20"
										to="360 20 20"
										dur="0.5s"
										repeatCount="indefinite"
									/>
								</path>
							</svg>
						</div>
					)}
				</div>
			</div>
			<RegisterUser
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				cell={country + phone}
			/>
			<Overlay
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false)
				}}
			/>
		</section>
	)
}
export default HomePage
